import React from 'react';

const LiftCurveExplanation = () => {
  return (
    <div className="text-sm text-gray-700 dark:text-gray-200 bg-gray-50 dark:bg-gray-800 p-4 rounded-lg border border-gray-200 dark:border-gray-700 leading-relaxed">
      <h3 className="text-md font-semibold text-gray-800 dark:text-gray-100 mb-3">Understanding Lift and Cumulative Lift Curves</h3>

      <p className="mb-4">The Lift and Cumulative Lift Curves show how effectively our model identifies high-value customers:</p>

      <div className="space-y-3 mb-4">
        <div>
          <h4 className="font-semibold text-gray-800 dark:text-gray-100 mb-1">Lift Curve (Blue Line)</h4>
          <p>Shows the model's ability to identify valuable customers within each 10 percent segment (decile) of your customer base, compared to a random selection.</p>
        </div>

        <div>
          <h4 className="font-semibold text-gray-800 dark:text-gray-100 mb-1">Cumulative Lift Curve (Green Line)</h4>
          <p>Shows the running average performance, helping determine the optimal portion of customers to target in campaigns for maximum efficiency.</p>
        </div>
      </div>

      <div className="mt-4 p-3 bg-blue-50  dark:bg-gray-800 border-l-4 border-blue-500  rounded-r-md">
        <p><strong className="font-semibold text-gray-800 dark:text-gray-100">Key Insight:</strong> A steeper downward slope in the curves indicates better separation between high-value and regular customers, helping guide strategic targeting decisions.</p>
      </div>
    </div>
  );
};

export default LiftCurveExplanation; 